if (window.location.href.includes('/collections/')) {
  const quickLinksSection = document.querySelector('.quick-links-section');
  if (!quickLinksSection) return;
  const quickLinks = quickLinksSection.querySelectorAll('.quick-link-item-link');
  const collectionHandle = quickLinksSection.getAttribute('data-collection-handle');

  quickLinks.forEach(link => {
    let linkHref = link.getAttribute('href');
    if (!linkHref) return;
    if (linkHref.includes('collection-name')) {
      linkHref = linkHref.replace('collection-name', collectionHandle);
      link.setAttribute('href', linkHref);
    }
  });
}